import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';

Alpine.directive('transition-height', (el, { modifiers }, { Alpine }) => {
    const duration = modifierValue(modifiers, 'duration', 250) / 1000
    const floor = modifierValue(modifiers, 'min', 0)
    const fullyHide = ! modifiers.includes('min')

    if (! el._x_isShown) el.style.height = `${floor}px`
    if (! el._x_isShown && fullyHide) el.hidden = true
    if (! el._x_isShown) el.style.overflow = 'hidden'

    let transitionStyles = {
        transitionProperty: 'height',
        transitionDuration: `${duration}s`,
        transitionTimingFunction: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    }

    el._x_transition = {
        in() {
            if (fullyHide) el.hidden = false;
            if (fullyHide) el.style.display = null

            let current = el.getBoundingClientRect().height

            el.style.height = 'auto'

            let full = el.getBoundingClientRect().height.toFixed(2)

            if (current === full) { current = floor }

            Alpine.transition(el, Alpine.setStyles, {
                during: transitionStyles,
                start: { height: current+'px' },
                end: { height: full+'px' },
            }, () => el._x_isShown = true, () => {
                let elementHeight = Number(el.style.height.replace('px', ''))

                elementHeight = elementHeight.toFixed(2)

                if (elementHeight == full) {
                    el.style.overflow = null
                }
            })
        },

        out() {
            let full = el.getBoundingClientRect().height

            Alpine.transition(el, setFunction, {
                during: transitionStyles,
                start: { height: full+'px' },
                end: { height: floor+'px' },
            }, () => el.style.overflow = 'hidden', () => {
                el._x_isShown = false

                // check if element is fully collapsed
                if (el.style.height == `${floor}px` && fullyHide) {
                    el.style.display = 'none'
                    el.hidden = true
                }
            })
        },
    }

    function modifierValue(modifiers, value, notFoundValue)
    {
        const index = modifiers.indexOf(value);

        if (index === -1) return notFoundValue;

        const modifierValue = index + 1;

        return modifiers[modifierValue] ?? notFoundValue;
    }

    let setFunction = (el, styles) => {
        let revertFunction = Alpine.setStyles(el, styles);

        return styles.height ? () => {} : revertFunction
    }
})
